import { createClient } from '@supabase/supabase-js';
import { apiEndpoints, isFeatureEnabled } from '../config/environment';

// Only create the client if Supabase is enabled and we have valid credentials
// This prevents the app from crashing on startup if keys are missing
export const supabase = (
  isFeatureEnabled('enableSupabase') &&
  apiEndpoints.supabaseUrl &&
  apiEndpoints.supabaseAnonKey &&
  !apiEndpoints.supabaseUrl.includes('YOUR_SUPABASE_URL')
) 
  ? createClient(apiEndpoints.supabaseUrl, apiEndpoints.supabaseAnonKey) 
  : null;
